let toggleFields = document.querySelectorAll(".toggle-fields");
let dataInput = document.querySelectorAll('[data-input]')


for (let i = 0; i < toggleFields.length; i++) {
		

		toggleFields[i].addEventListener('change', function(){
				let v = this;
				let vValue = this.value.toLowerCase();
				let parent = v.parentElement;
				let dataInput = parent.querySelectorAll('[data-input]');

				for (let t = 0; t < dataInput.length; t++) {
						let tValue = dataInput[t].dataset.input.toLowerCase();

						if (tValue == vValue) {
								dataInput[t].classList.remove('hidden');
						} else if (vValue == 'ja') {
								dataInput[t].classList.remove('hidden');
						} else {
								dataInput[t].classList.add('hidden');
						}
				}
		});
};

$('.eier').hide();
$('.leier').hide();

$('#HouseType').change(function () {
		var value = $(this).find('option:selected').val();
		if (value == 'Eier bolig') {
				$('.eier').show();
				$('.leier').show();
		} else if (value == 'Leier bolig') {
				$('.leier').show();
				$('.eier').hide();
		}
		else if (value == 'Vennligst velg') {
				$('.eier').hide();
				$('.leier').hide();
		}
});

